<template>
  <div class="home">
    <el-container>
      <el-header style="height: 108px">
        <header-page />
      </el-header>

      <el-main>
        <router-view />
        <div id="map">
          <div class="hidenMapbg" v-show="hidenMap">占位</div>
          <drawn-map></drawn-map>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
  // 导入地图
  import drawnMap from '@/components/drawn-map/drawn-map'
  import headerPage from './components/header.vue'
  export default {
    components: { headerPage, drawnMap },
    data() {
      return {
        hidenMap: false,
      }
    },
    watch: {
      $route: {
        immediate: true,
        handler(to) {
          if (to.meta.hidenMap) {
            this.hidenMap = to.meta.hidenMap
          } else {
            this.hidenMap = false
          }
        },
      },
    },
    methods: {},
  }
</script>
<style lang="scss" scoped>
  .home {
    width: 100%;
    height: 100vh;
    overflow: hidden;
  }
  .el-container {
    height: 100%;
  }
  .el-header {
    padding: 0;
  }
  .el-main {
    overflow: hidden;
  }
  // 地图
  #map {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1;
    background-image: url('../../assets/images/command-center/command-centre-bg.png');
    background-size: 100% 100%;
  }
  .hidenMapbg {
    background: #040708;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 2;
    opacity: 0.9;
  }
</style>
